import api from '@/api/api';
import { SHIPMENTS_API } from '@/variables';
import Shipment from '@/models/Shipment';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    list_for_valuating(_, payload) {
      const { page, itemsPerPage } = payload;
      return api().get(`${SHIPMENTS_API}/list_for_valuation`, { params: { page, itemsPerPage } })
        .then((resp) => resp.data);
    },
    valuate(_, payload) {
      const { id, cost } = payload;
      return api().post(`${SHIPMENTS_API}/${id}/valuate`, { cost })
        .then((resp) => resp.data);
    },
    valuate_skip(_, payload) {
      const { id } = payload;
      return api().post(`${SHIPMENTS_API}/${id}/valuate_skip`)
        .then((resp) => resp.data);
    },
    get_list({ rootGetters }, payload) {
      const { status, type, page, search } = payload;
      const section = rootGetters.get_app_section;

      return api().get(`${section}${SHIPMENTS_API}/${status}/${type}`,
        { params: { page, search } })
        .then((resp) => resp.data)
        .then((data) => {
          if (data.count === 0) return data;
          data.data = data.data.map((item) => new Shipment(item));
          return data;
        });
    },
    add_tracking_code({ rootGetters }, payload) {
      const { id, tracking_code } = payload;
      const section = rootGetters.get_app_section;

      return api().put(`${section}${SHIPMENTS_API}/${id}/addTrackingCode`, { tracking_code })
        .then((resp) => resp.data);
    },
    toggle_printed({ rootGetters }, payload) {
      const { id, state } = payload;
      const section = rootGetters.get_app_section;

      return api().put(`${section}${SHIPMENTS_API}/${id}/printed/${state}`)
        .then((resp) => {
          if (resp.status !== 200) throw new Error();
          return resp.data;
        });
    },
    ship({ rootGetters }, payload) {
      const { id } = payload;
      const section = rootGetters.get_app_section;

      return api().put(`${section}${SHIPMENTS_API}/${id}/ship`)
        .then((resp) => {
          if (resp.status !== 200) throw new Error();
          return resp.data;
        });
    },
    delete({ rootGetters }, payload) {
      const { id } = payload;
      const section = rootGetters.get_app_section;

      return api().delete(`${section}${SHIPMENTS_API}/${id}`)
        .then((resp) => {
          if (resp.status !== 200) throw new Error();
          return resp.data;
        });
    },
    submit_fba({ rootGetters }, payload) {
      const { id, form } = payload;
      const section = rootGetters.get_app_section;

      return api()
        .put(`${section}${SHIPMENTS_API}/${id}/submitFba`, form)
        .then((resp) => resp.data);
    },
  },
};
